import { Injectable } from '@angular/core';
import { MapModalComponent } from '@amdb/drone/shared/components/map-modal/map-modal.component';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { GeomModel } from '@amdb/drone/shared/models/geom.model';

@Injectable({
    providedIn: 'root',
})
export class MapModalService {
    constructor(private dialogService: NbDialogService) {}

    async open(...geometries: GeomModel[]): Promise<void> {
        const mapDialog: NbDialogRef<MapModalComponent> = this.dialogService.open(MapModalComponent, { context: { geometries: geometries } });
        return await mapDialog.onClose.toPromise();
    }
}
